import { useTranslation } from "react-i18next";
import styles from "@/components/appointmentRequest/appointmentRequestNoAvailableDaysMessage.module.css";

export function AppointmentRequestNoAvailableDaysMessage() {
  const { t } = useTranslation();

  return (
    <span className={styles.message}>
      {t("error_all_slots_taken_please_contact")}
    </span>
  );
}
